import {getPaginationActions} from 'components/pagination/pagination.actions';
import {companyJobsActionTypes} from './company-jobs.actions';

import CompanyTemplate from './company.component.html';
import './company.component.scss';

/**
 * @ngdoc controller
 * @name CompanyController
 * @module portfolium.CompanyController
 **/
class CompanyController {
    /**
    * @ngdoc method
    * @name CompanyController#constructor
    * @methodOf CompanyController
    */
    constructor($state, $stateParams, $ngRedux, $pfJobs, PF_JOB_TRAFFIC_SOURCES) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$ngRedux = $ngRedux;
        this.$pfJobs = $pfJobs;
        this.trafficSource = PF_JOB_TRAFFIC_SOURCES.companyPage;
    }

    $onInit() {
        // get company slug
        this.companySlug = this.$stateParams.slug;

        // Configure pagination actions
        const paginationActions = getPaginationActions({
            actionTypes: companyJobsActionTypes,
            getResults: this.getJobs.bind(this),
        });

        // Subscribe to application state changes and map actions to this
        this._unsubscribe = this.$ngRedux.connect(
            this._mapStateToThis,
            paginationActions
        )(this);

        // Load first set of job results
        this.initPage();
    }

    /**
    * @ngdoc method
    * @name CompanyDetails#$onDestroy
    * @methodOf CompanyDetails
    * @description
    * UnSubscribe to ngRedux
    **/
    $onDestroy() {
        this._unsubscribe();
    }

    /**
    * @ngdoc method
    * @name CompanyDetails#_mapStateToThis
    * @methodOf CompanyDetails
    * @description
    * Maps company and jobs to the controller
    * @param  {Object} state current state.
    * @return {Object} New state of company and jobs.
    **/
    _mapStateToThis(state) {
        return {
            company: state.companyDetails.meta.company,
            pagination: state.companyDetails.jobs,
        };
    }

    /**
      * @ngdoc method
      * @name searchCompanyJobs
      * @description Transition to jobs page filtered by current company and anywhere
      */
    searchCompanyJobs() {
        this.$state.go('searchJobs', {
            company: this.company.name,
            anywhere: true,
        });
    }

    /**
      * @ngdoc method
      * @name getJobs
      * @description gets company jobs and udates application state
      * @param {Integer} companyId
      */
    getJobs() {
        let params = _.assign({}, this.pagination.query, {sort: 'recent'});

        // Get jobs and update application state
        return this.$pfJobs.getJobsByCompanySlug(this.companySlug, params);
    }
}

CompanyController.$inject = [
    '$state',
    '$stateParams',
    '$ngRedux',
    '$pfJobs',
    'PF_JOB_TRAFFIC_SOURCES'
];

/**
 * @ngdoc component
 * @name CompanyComponent
 * @module portfolium.CompanyComponent
 **/
export const CompanyComponent = {
    template: CompanyTemplate,
    controller: CompanyController,
    controllerAs: '$ctrl'
};
